module.exports = __webpack_public_path__ + "img/circuit.359670dc.png";